module.exports = window["MaterialUI"].createMuiTheme;